import React from 'react'
import { ContactCompanyFragment } from '../src/model/fragments'
import { escapedNewLineToLineBreakTag } from '../src/utils/escapedNewLineToLineBreakTag'

export interface CompanyDetailProps {
	company?: ContactCompanyFragment
	fallbackName?: string
	fallbackAddress?: string
}

export const CompanyDetail: React.FunctionComponent<CompanyDetailProps> = ({
	company,
	fallbackName,
	fallbackAddress,
}) => {
	return (
		<section className="companyDetail">
			<h3 className="companyDetail-title">{company?.name || fallbackName}</h3>
			{company ? (
				<>
					{company.address && <div>Sídlo firmy: {company.address}</div>}
					{(company.companyId || company.vatId) && (
						<div>
							IČO: {company.companyId}, DIČ: {company.vatId}
						</div>
					)}
					{company.legalStatus && (
						<div>Právní forma: {company.legalStatus}</div>
					)}
					{company.referenceNumber && (
						<div>Spisová značka: {company.referenceNumber}</div>
					)}
				</>
			) : (
				escapedNewLineToLineBreakTag(fallbackAddress || '')
			)}
		</section>
	)
}
